import SEO from "@/components/SEO";
import { MaskedLines, Reveal } from "@/components/Reveal";
import FAQAccordion from "@/components/FAQAccordion";
import { CTABanner } from "@/components/sections";

const POLICIES = [
  { h: "Booking & deposits", b: "Select services and first-time color appointments may require a card on file or deposit to reserve. Deposits apply toward your service total." },
  { h: "Late arrivals", b: "Arriving more than 15 minutes late may require us to shorten or reschedule your service so we can honor the next guest." },
  { h: "Cancellations & no-shows", b: "Please give at least 24 hours' notice. Late cancellations and no-shows may incur a fee of up to 50% of the booked service." },
  { h: "Health & allergies", b: "Please disclose allergies, sensitivities, pregnancy, or skin conditions before treatment. Patch tests are available and recommended for color and peels." },
  { h: "Children & guests", b: "For safety and calm, we ask that only those receiving services be present in treatment areas when possible." },
  { h: "Refunds", b: "Services are non-refundable, but your satisfaction matters — if something isn't right, contact us within 7 days and we'll make it right." },
];

export default function FAQ() {
  return (
    <>
      <SEO
        title="Salon Policies & FAQ — Hell's Kitchen, NYC"
        description="Maison Neuf salon policies and frequently asked questions: booking, cancellations, hygiene, consultations, and more for our Hell's Kitchen, Manhattan location."
      />
      <section className="mx-auto max-w-[1400px] px-5 pt-36 pb-16 md:px-10 md:pt-44" data-testid="faq-hero">
        <p className="label mb-6 text-wine">Policies & FAQ</p>
        <h1 className="max-w-4xl font-display text-5xl leading-[1.0] md:text-8xl">
          <MaskedLines lines={["Everything", "you asked."]} />
        </h1>
      </section>

      <section className="mx-auto grid max-w-[1400px] gap-14 px-5 pb-16 md:grid-cols-12 md:px-10" data-testid="faq-body">
        <div className="md:col-span-7">
          <p className="label mb-6 text-wine">Frequently asked</p>
          <FAQAccordion />
        </div>
        <div className="md:col-span-5 md:border-l md:border-border md:pl-12">
          <p className="label mb-6 text-wine">Salon policies</p>
          <div className="space-y-8">
            {POLICIES.map((p, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div>
                  <h3 className="font-display text-xl">{p.h}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{p.b}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABanner title="Still have a question?" sub="Call or text us — a real person will answer during salon hours." />
    </>
  );
}
